import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
  70%  { box-shadow: 0 0 0 14px rgba(37, 211, 102, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
`;

const Btn = styled.a`
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 999;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #25D366;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0,0,0,0.22);
  animation: ${pulse} 2.4s ease-out infinite;
  transition: transform 0.2s, background 0.2s;

  &:hover {
    transform: scale(1.1);
    background: #1ebe5a;
  }

  svg {
    width: 28px;
    height: 28px;
    fill: #ffffff;
  }

  @media (max-width: 560px) {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
`;

const WHATSAPP_NUMBER = '2347077219592';

function WhatsAppButton() {
  return (
    <Btn
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      {/* WhatsApp SVG icon */}
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.003 2.667C8.639 2.667 2.667 8.638 2.667 16c0 2.35.632 4.64 1.833 6.642L2.667 29.333l6.878-1.796A13.27 13.27 0 0016.003 29.333C23.365 29.333 29.333 23.362 29.333 16S23.365 2.667 16.003 2.667zm0 24.133a10.93 10.93 0 01-5.575-1.526l-.4-.237-4.082 1.066 1.087-3.975-.261-.41A10.906 10.906 0 015.11 16c0-6.006 4.888-10.893 10.894-10.893S26.896 9.994 26.896 16 22.009 26.8 16.003 26.8zm5.976-8.163c-.327-.164-1.934-.954-2.234-1.062-.299-.11-.517-.164-.734.163-.218.328-.844 1.063-1.035 1.281-.19.217-.381.245-.708.082-.327-.164-1.38-.509-2.628-1.621-.972-.866-1.628-1.935-1.818-2.262-.19-.327-.02-.504.143-.667.147-.146.327-.381.49-.572.164-.19.218-.327.327-.544.11-.218.055-.408-.027-.572-.082-.163-.734-1.771-1.006-2.424-.265-.637-.534-.55-.735-.56l-.626-.01c-.218 0-.572.081-.871.408-.299.327-1.143 1.117-1.143 2.724s1.17 3.158 1.334 3.376c.163.217 2.302 3.514 5.578 4.928.78.337 1.388.538 1.863.688.783.249 1.496.214 2.059.13.628-.094 1.934-.79 2.207-1.553.272-.762.272-1.416.19-1.553-.08-.136-.298-.217-.625-.38z" />
      </svg>
    </Btn>
  );
}

export default WhatsAppButton;
